<template>
    <v-modal-validated title="Añadir una nueva entidad"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :rules="rules"
                       id="add-entities-modal"
                       size="xl"
                       v-if="rules_loaded"
                       @closed="closeModal"
                       @accepted="addEntity">
        <div class="form-container">
            <div class="user-form row">
                <div class="form-group col-5">
                    <label>NIF*:</label>
                    <Field type="text" name="nif" class="form-control" v-model="entity.nif"/>

                    <ErrorMessage name="nif"/>
                </div>

                <div class="form-group col-7">
                    <label>Nombre corto*:</label>
                    <Field type="text" name="short_name" class="form-control" v-model="entity.short_name"/>

                    <ErrorMessage name="short_name"/>
                </div>
            </div>

            <div class="user-form row pb-3">
                <div class="form-group col-12">
                    <label>Nombre*:</label>
                    <Field type="text" name="name" class="form-control" ref="email" v-model="entity.name"/>

                    <ErrorMessage name="name"/>
                </div>
            </div>

            <div class="user-form row">
                <div class="more-fields row" id="more_fields">
                    <div class="form-group" :class="field.class" v-for="field in fields">
                        <label :for="field.name">{{ field.display_name }}{{
                                !!field.rules && isRequired(field.rules) === true ? '*' : null
                            }}</label>

                        <Field :type="field.type"
                               class="form-control"
                               :name="field.name"
                               :id="field.name"
                               :list="field.datalist ? field.datalist : null"
                               :disabled="field.disabled === true ? true : null"
                               v-model="entity[field.name]"
                               v-if="field.name !== 'town'"/>

                        <Field id="town_datalist" :name="field.name" v-if="field.name === 'town'"  class="form-control" v-model="entity[field.name]">
                            <v-select-jq class="form-select"
                                         parent-id="add-entities-modal"
                                         placeholder="- Seleccionar -"
                                         :options="townsOptions"
                                         :modelValue="entity[field.name]"
                                         @update:modelValue="entity[field.name] = $event; townUpdated(entity[field.name])">
                            </v-select-jq>
                        </Field>

                        <datalist id="type_road_datalist" v-if="field.name === 'type_road'">
                            <option :value="element" v-for="element in forms_help.road_types">{{ element }}</option>
                        </datalist>

                        <ErrorMessage :name="field.name"/>
                    </div>
                </div>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>
import {getCCAAs, getProvinces, getRoadTypes, getTowns} from "../../../helpers/DataHelper";
import {createEntity} from "../../../helpers/requests/RequestsEntities";
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import {addRule, isRequired} from "../../../helpers/form";
import VSelectJq from "../../general/VSelectJQ";

export default {
    name: "EntitiesListAddModal",
    components: {VModalValidated, Form, Field, ErrorMessage, VSelectJq},
    data() {
        return {
            entity: {},
            fields: [],
            rules_loaded: false,

            townsOptions: [],

            forms_help: {
                ccaas: getCCAAs(),
                provinces: getProvinces(),
                towns: getTowns(),
                road_types: getRoadTypes(),
            },

            rules: {
                nif: yup.string().required('Debes incluir el NIF de la entidad').max(50, 'Debe tener como máximo 50 caracteres'),
                short_name: yup.string().required('Debes incluir un nombre corto').max(50, 'Debe tener como máximo 50 caracteres'),
                name: yup.string().required('Debes incluir un nombre').max(50, 'Debe tener como máximo 50 caracteres'),
            }
        }
    },
    setup() {
        return {
            isRequired,
        }
    },
    mounted() {
        this.fields = require('../../../config/form_fields.json').entities;

        this.rules_loaded = true;

        for (let i in this.fields) {
            let field = this.fields[i];
            let add = yup;

            for (let j in field.rules) {
                let rule = field.rules[j];

                let name = rule.name;
                let message = rule.message;
                add = addRule(add, name, message);
            }

            this.rules[field.name] = add;
        }

        this.rules = yup.object(this.rules);

        let array = Object.keys(this.forms_help.towns);
        for (let i in array) {
            let town = array[i];
            this.townsOptions.push({id: town, text: town,});
        }
    },
    methods: {
        async addEntity(data) {
            try {
                if (data.town) {
                    // As we used '(PROVINCE)' + to allow differentiating duplicated city names, we remove that suffix
                    data.town = data.town.replaceAll('(' + data.province + ')', '').trim();
                }

                await createEntity(data);

                this.$store.dispatch('app/setToastMessage', 'Entidad añadida');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al crear la entidad');
            }
        },
        townUpdated(town) {
            if (this.forms_help.towns[town] !== undefined) {
                let location = this.forms_help.towns[town];
                // set ccaa | province
                this.entity['community'] = location.ccaa;
                this.entity['province'] = location.province;
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
